import Combobox from 'react-widgets/lib/Combobox';
import { Col, Row } from 'react-bootstrap';
import React, { Component } from 'react';
const isEmpty = require('is-empty');

class DeliveryAddressModal extends Component {

    state = {
        isValidInnerBranchId: false,
        isValidCodigoPostal:  false,
        isValidLocalidad:     false,
        isValidPoblacion:     false,
        isValidLongitud:      false,
        isValidListaMB:       false,
        isValidLatitud:       false,
        isValidColonia:       false,
        isValidNombre:        false,
        isValidCiudad:        false,
        isValidEstado:        false,
        isValidCalle:         false,
        errorInnerBranchId:   '',
        errorCodigoPostal:    '',
        errorLocalidad:       '',
        errorPoblacion:       '',
        errorLongitud:        '',
        errorListaMB:         '',
        errorLatitud:         '',
        errorColonia:         '',
        errorCiudad:          '',
        errorEstado:          '',
        errorNombre:          '',
        errorCalle:           '',
        numeroExterior:       '',
        numeroInterior:       '',
        innerBranchId:        '',
        codigoPostal:         '',
        localidad:            '',
        poblacion:            '',
        longitud:             '',
        listaMb:              '',
        latitud:              '',
        colonia:              '',
        nombre:               '',
        ciudad:               '',
        estado:               '',
        calle:                '',
    }

    constructor(props) {
        super(props);
        this.deactivateBranch = this.deactivateBranch.bind(this);
        this.preparateUpdate  = this.preparateUpdate.bind(this);
        this.preparateCreate  = this.preparateCreate.bind(this);
        this.activateBranch   = this.activateBranch.bind(this);
        this.onPressCancel    = this.onPressCancel.bind(this);
		document.addEventListener('keydown', this.onPressEsc, false);
	}

    componentDidMount() {
        if (this.props.type === 'UPDATE') {
            this.setState({
                nombre:         this.props.deliveryAddressData.nombre !== null ? this.props.deliveryAddressData.nombre : '',
                innerBranchId:  this.props.deliveryAddressData.innerBranchId !== null ? this.props.deliveryAddressData.innerBranchId : '',
                listaMb:        this.props.deliveryAddressData.listaMb !== null ? this.props.deliveryAddressData.listaMb : '',
                latitud:        this.props.deliveryAddressData.latitud !== null ? this.props.deliveryAddressData.latitud : '',
                longitud:       this.props.deliveryAddressData.longitud !== null ? this.props.deliveryAddressData.longitud : '',
                calle:          this.props.deliveryAddressData.direccion.calle !== null ? this.props.deliveryAddressData.direccion.calle : '',
                colonia:        this.props.deliveryAddressData.direccion.colonia !== null ? this.props.deliveryAddressData.direccion.colonia : '',
                numeroExterior: this.props.deliveryAddressData.direccion.numeroExterior !== null ? this.props.deliveryAddressData.direccion.numeroExterior : '',
                numeroInterior: this.props.deliveryAddressData.direccion.numeroInterior !== null ? this.props.deliveryAddressData.direccion.numeroInterior : '',
                localidad:      this.props.deliveryAddressData.direccion.localidad !== null ? this.props.deliveryAddressData.direccion.localidad : '',
                poblacion:      this.props.deliveryAddressData.direccion.poblacion !== null ? this.props.deliveryAddressData.direccion.poblacion : '',
                ciudad:         this.props.deliveryAddressData.direccion.ciudad !== null ? this.props.deliveryAddressData.direccion.ciudad : '',
                estado:         this.props.deliveryAddressData.direccion.estado !== null ? this.props.deliveryAddressData.direccion.estado : '',
                codigoPostal:   this.props.deliveryAddressData.direccion.codigoPostal !== null ? this.props.deliveryAddressData.direccion.codigoPostal : '',
            });
        } else {
            this.setState({
                listaMb:        this.props.socialReasonSelected.listaPrecioMB !== null ? this.props.socialReasonSelected.listaPrecioMB : '' 
            });
        }
    }

    ///---------------------------------------EVENTS-------------------------------------
    
    onPressEsc = (event) => {
        if (event.keyCode === 27) {
            this.onPressCancel();
		}
	}
    
    onPressCancel() {
        this.props.onPressCancel();
    }

    async preparateUpdate() {
		await this.clearErrors();
		this.validate();
		if (
            this.state.isValidInnerBranchId && this.state.isValidCodigoPostal && this.state.isValidLocalidad &&
            this.state.isValidLongitud      && this.state.isValidListaMB      && this.state.isValidLatitud   && 
            this.state.isValidColonia       && this.state.isValidNombre       && this.state.isValidCiudad    && 
            this.state.isValidEstado        && this.state.isValidCalle
        ) {
            const data = {
                id:            this.props.deliveryAddressData._id,
                nombre:        this.state.nombre,
                innerBranchId: this.state.innerBranchId,
                longitud:      this.state.longitud,
                latitud:       this.state.latitud,
                listaMb:       this.state.listaMb,
                direccion:     {
                    id:             this.props.deliveryAddressData.direccion.id,
                    calle:          this.state.calle,
                    numeroExterior: this.state.numeroExterior,
                    numeroInterior: this.state.numeroInterior,
                    colonia:        this.state.colonia,
                    localidad:      this.state.localidad,
                    poblacion:      this.state.poblacion,
                    ciudad:         this.state.ciudad,
                    estado:         this.state.estado,
                    codigoPostal:   this.state.codigoPostal,
                    latitud:        this.props.deliveryAddressData.direccion.latitud,
                    longitud:       this.props.deliveryAddressData.direccion.longitud
                }
            };
            this.cleanForm();
			this.props.updateBranch(
				data
			);
		}
	}

    async preparateCreate() {
        await this.clearErrors();
		this.validate();
		if (
            this.state.isValidInnerBranchId && this.state.isValidCodigoPostal && this.state.isValidLocalidad &&
            this.state.isValidPoblacion     && this.state.isValidLongitud     && this.state.isValidListaMB   &&
            this.state.isValidLatitud       && this.state.isValidColonia      && this.state.isValidNombre    && 
            this.state.isValidCiudad        && this.state.isValidEstado       && this.state.isValidCalle
        ) {
            const data = {
                razonSocialId: this.props.socialReasonSelected._id,
                branch:        {
                    nombre:        this.state.nombre,
                    innerBranchId: this.state.innerBranchId,
                    longitud:      this.state.longitud,
                    latitud:       this.state.latitud,
                    listaMb:       this.state.listaMb,
                    direccion:     {
                        calle:          this.state.calle,
                        numeroExterior: this.state.numeroExterior,
                        numeroInterior: this.state.numeroInterior,
                        colonia:        this.state.colonia,
                        localidad:      this.state.localidad,
                        ciudad:         this.state.ciudad,
                        estado:         this.state.estado,
                        codigoPostal:   this.state.codigoPostal,
                        poblacion:      this.state.poblacion,
                    }
                }
            };
            this.cleanForm();
			this.props.createBranch(
				data
			);
		}
    }

    activateBranch() {
		this.props.activateBranch(this.props.deliveryAddressData._id);
	}

	deactivateBranch() {
		this.props.deactivateBranch(this.props.deliveryAddressData._id);
	}

    clearErrors = () => {
		this.setState({
            errorInnerBranchId: '',
            errorCodigoPostal:  '',
            errorLocalidad:     '',
            errorPoblación:     '',
            errorLongitud:      '',
            errorListaMB:       '',
            errorLatitud:       '',
            errorColonia:       '',
            errorCiudad:        '',
            errorEstado:        '',
            errorNombre:        '',
            errorCalle:         '',
		})
	}

    cleanForm() {
		this.setState({
			numeroExterior: '',
			numeroInterior: '',
            innerBranchId:  '',
            codigoPostal:   '',
            localidad:      '',
            poblacion:      '',
            longitud:       '',
            listaMb:        '',
            latitud:        '',
            colonia:        '',
            nombre:         '',
            ciudad:         '',
            estado:         '',
            calle:          '',
		});
	}

    validate() {
        this.setState({
            isValidInnerBranchId: (this.state.innerBranchId === '' && isEmpty(this.state.innerBranchId)) ? false : true,
            isValidCodigoPostal:  (this.state.codigoPostal  === '' && isEmpty(this.state.codigoPostal))  ? false : true,
            isValidLocalidad:     (this.state.localidad     === '' && isEmpty(this.state.localidad))     ? false : true,
            isValidPoblacion:     (this.state.poblacion     === '' && isEmpty(this.state.poblacion))     ? false : true,
            isValidLongitud:      (this.state.longitud      === '' && isEmpty(this.state.longitud))      ? false : true,
            isValidListaMB:       (this.state.listaMb       === '' && isEmpty(this.state.listaMb))       ? false : true,
            isValidLatitud:       (this.state.latitud       === '' && isEmpty(this.state.latitud))       ? false : true,
            isValidColonia:       (this.state.colonia       === '' && isEmpty(this.state.colonia))       ? false : true,
            isValidCiudad:        (this.state.ciudad        === '' && isEmpty(this.state.ciudad))        ? false : true,
            isValidEstado:        (this.state.estado        === '' && isEmpty(this.state.estado))        ? false : true,
            isValidNombre:        (this.state.nombre        === '' && isEmpty(this.state.nombre))        ? false : true,
            isValidCalle:         (this.state.calle         === '' && isEmpty(this.state.calle))         ? false : true,
            errorInnerBranchId:   this.state.innerBranchId  ? '' : 'El InnerBranch Id es requerido',
            errorCodigoPostal:    this.state.codigoPostal   ? '' : 'El código postal es requerido', 
            errorLocalidad:       this.state.localidad      ? '' : 'La localidad es requerida',
            errorPoblacion:       this.state.poblacion      ? '' : 'La población es requerida',
            errorLongitud:        this.state.longitud       ? '' : 'La longitud es requerida',
            errorListaMB:         this.state.listaMb        ? '' : 'La lista MB es requerida',
            errorLatitud:         this.state.latitud        ? '' : 'La latitud es requerida',
            errorColonia:         this.state.colonia        ? '' : 'La colonia es requerida',
            errorCiudad:          this.state.ciudad         ? '' : 'La ciudad es requerida',
            errorEstado:          this.state.estado         ? '' : 'El estado es requerido',
            errorNombre:          this.state.nombre         ? '' : 'El nombre de la dirección es requerida',
            errorCalle:           this.state.calle          ? '' : 'El nombre de la calle es requerida',
        });
    }

    onChangeNombre = (e) => {
		this.setState({
			nombre:      e.target.value,
            errorNombre: ''
		});
	}

    onChangeInnerBranchId = (e) => {
		this.setState({
			innerBranchId:      e.innerBranchId,
            errorInnerBranchId: ''
		});
	}

    onChangeListaMB = (e) => {
		this.setState({
			listaMb:      e.target.value,
            errorListaMb: ''
		});
	}

    onChangeLatitud= (e) => {
		this.setState({
			latitud:      e.target.value,
            errorLatitud: ''
		});
	}

    onChangeLongitud = (e) => {
		this.setState({
			longitud:      e.target.value,
            errorLongitud: ''
		});
	}

    onChangeCalle = (e) => {
		this.setState({
			calle:      e.target.value,
            errorCalle: ''
		});
	}
    onChangeColonia = (e) => {
		this.setState({
			colonia:      e.target.value,
            errorColonia: ''
		});
	}

    onChangeNumeroExterior = (e) => {
		this.setState({
			numeroExterior:      e.target.value,
		});
	}

    onChangeNumeroInterior = (e) => {
		this.setState({
			numeroInterior:      e.target.value,
		});
	}

    onChangeLocalidad = (e) => {
		this.setState({
			localidad:      e.target.value,
            errorLocalidad: ''
		});
	}

    onChangePoblacion = (e) => {
		this.setState({
			poblacion:      e.target.value,
            errorPoblación: ''
		});
	}

    onChangeCiudad = (e) => {
		this.setState({
			ciudad:      e.target.value,
            errorCiudad: ''
		});
	}

    onChangeEstado = (e) => {
		this.setState({
			estado:      e.target.value,
            errorEstado: ''
		});
	}

    onChangeCodigoPostal = (e) => {
		this.setState({
			codigoPostal:      e.target.value,
            errorCodigoPostal: ''
		});
	}

    ///---------------------------------------VIEW-------------------------------------

    render() {
		const title = this.props.type === 'CREATE' ? 'CAPTURA LOS SIGUIENTES DATOS' : 'ACTUALIZACIÓN DE DIRECCIÓN DE ENTREGA';
		return (
			<div className="modal display-block">
                <div className="modal-center-main">
                    <div className="auth-group" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                        <center>{title}</center>
                        <div className="auth-label"></div>
                        <div className="auth-label"></div>
                        <form ref={(el) => { this.farmazonFormRef = el }}>
                            <Row>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Nombre:
                                        <span className="required">*</span>
                                        <input
                                            id="nombreForm"
                                            ref={(el) => { this.nombreForm = el }}
                                            onChange={this.onChangeNombre.bind(this)}
                                            value={this.state.nombre}
                                            error={this.state.errorNombre}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: Farmacia centro"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorNombre}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Centro Farmazon:
                                        <span className="required">*</span>
                                        <div className="row-multiselect-roles">
                                            <Combobox
                                                className="select-roles"
                                                data={this.props.centers}
                                                textField='nombre'
                                                valueField='innerBranchId'
                                                filter='contains'
                                                value= { this.state.innerBranchId }
                                                placeholder="Seleccione una opción"
                                                onChange={this.onChangeInnerBranchId.bind(this)}
                                            />
                                        </div>
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorInnerBranchId}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Lista de precios MB:
                                        <span className="required">*</span>
                                        <input
                                            id="listaMbForm"
                                            ref={(el) => { this.listaMbForm = el }}
                                            onChange={this.onChangeListaMB.bind(this)}
                                            value={this.state.listaMb}
                                            error={this.state.errorListaMB}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: 1"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorListaMb}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                {(this.state.latitud === '' || this.state.latitud === null || this.props.type === 'CREATE') &&
                                    <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                        <div className="auth-label">
                                            Latitud:
                                            <span className="required">*</span>
                                            <input
                                                id="latitudForm"
                                                ref={(el) => { this.listaMbForm = el }}
                                                onChange={this.onChangeLatitud.bind(this)}
                                                value={this.state.latitud}
                                                error={this.state.errorLatitud}
                                                type="number"
                                                className="local-store-input"
                                                placeholder="Ej.: 19.7645802"
                                            />
                                        </div>
                                        <div className="auth-error">
                                            {this.state.errorLatitud}
                                        </div>
                                    </Col>
                                }
                                {(this.state.longitud === '' || this.state.longitud === null || this.props.type === 'CREATE') &&
                                    <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                        <div className="auth-label">
                                            Longitud:
                                            <span className="required">*</span>
                                            <input
                                                id="longitudForm"
                                                ref={(el) => { this.longitudForm = el }}
                                                onChange={this.onChangeLongitud.bind(this)}
                                                value={this.state.longitud}
                                                error={this.state.errorLongitud}
                                                type="number"
                                                className="local-store-input"
                                                placeholder="Ej.: 19.7645802"
                                            />
                                        </div>
                                        <div className="auth-error">
                                            {this.state.errorLongitud}
                                        </div>
                                    </Col>
                                }
                            </Row>
                            <h5>Dirección:</h5>
                            <Row>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Calle:
                                        <span className="required">*</span>
                                        <input
                                            id="calleForm"
                                            ref={(el) => { this.calleForm = el }}
                                            onChange={this.onChangeCalle.bind(this)}
                                            value={this.state.calle}
                                            error={this.state.errorCalle}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: 18 de Julio"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorCalle}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Colonia:
                                        <span className="required">*</span>
                                        <input
                                            id="coloniaForm"
                                            ref={(el) => { this.coloniaForm = el }}
                                            onChange={this.onChangeColonia.bind(this)}
                                            value={this.state.colonia}
                                            error={this.state.errorColonia}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: San Pedro"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorColonia}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Número exterior:
                                        <input
                                            id="numeroExteriorForm"
                                            ref={(el) => { this.numeroExteriorForm = el }}
                                            onChange={this.onChangeNumeroExterior.bind(this)}
                                            value={this.state.numeroExterior}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: 19"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Número interior:
                                        <input
                                            id="numeroInteriorForm"
                                            ref={(el) => { this.numeroInteriorForm = el }}
                                            onChange={this.onChangeNumeroInterior.bind(this)}
                                            value={this.state.numeroInterior}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: 12"
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Localidad:
                                        <span className="required">*</span>
                                        <input
                                            id="localidadForm"
                                            ref={(el) => { this.localidadForm = el }}
                                            onChange={this.onChangeLocalidad.bind(this)}
                                            value={this.state.localidad}
                                            error={this.state.errorLocalidad}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: Nopancalco"
                                            />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorLocalidad}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Población:
                                        { this.props.type === 'CREATE' &&
                                            <span className="required">*</span>
                                        }
                                        <input
                                            id="poblacionForm"
                                            ref={(el) => { this.poblacionForm = el }}
                                            onChange={this.onChangePoblacion.bind(this)}
                                            value={this.state.poblacion}
                                            error={this.state.errorPoblacion}
                                            type="text"
                                            className="local-store-input"
                                        />
                                    </div>
                                    { this.props.type === 'CREATE' &&
                                        <div className="auth-error">
                                            {this.state.errorPoblacion}
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Ciudad:
                                        <span className="required">*</span>
                                        <input
                                            id="ciudadForm"
                                            ref={(el) => { this.ciudadForm = el }}
                                            onChange={this.onChangeCiudad.bind(this)}
                                            value={this.state.ciudad}
                                            error={this.state.errorCiudad}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: Pachuca"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorCiudad}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Estado:
                                        <span className="required">*</span>
                                        <input
                                            id="estadoForm"
                                            ref={(el) => { this.estadoForm = el }}
                                            onChange={this.onChangeEstado.bind(this)}
                                            value={this.state.estado}
                                            error={this.state.errorEstado}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: Hidalgo"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorEstado}
                                    </div>
                                </Col>
                                <Col xs={12} md={4} sm={12} lg={4} style={{ marginTop: '1vh' }}>
                                    <div className="auth-label">
                                        Código postal:
                                        <span className="required">*</span>
                                        <input
                                            id="codigoPostalForm"
                                            ref={(el) => { this.codigoPostalForm = el }}
                                            onChange={this.onChangeCodigoPostal.bind(this)}
                                            value={this.state.codigoPostal}
                                            error={this.state.errorCodigoPostal}
                                            type="text"
                                            className="local-store-input"
                                            placeholder="Ej.: 42108"
                                        />
                                    </div>
                                    <div className="auth-error">
                                        {this.state.errorCodigoPostal}
                                    </div>
                                </Col>
                            </Row>
							<div className="auth-label"></div>
                        </form>
                        <br/>
                        <div className="modal-activity-section">
                            {
                                this.props.type !== 'UPDATE' &&
                                <button className="modal-buttonOK" onClick={this.preparateCreate}>GUARDAR</button>
                            }
                            {
                                this.props.type === 'UPDATE' &&
                                <button className="modal-buttonOK" onClick={this.preparateUpdate}>ACTUALIZAR</button>
                            }
                            {/*
                                this.props.type === 'UPDATE' && this.props.deliveryAddressData && this.props.deliveryAddressData.is_active === true &&
                                <button className="modal-buttonDelete" onClick={this.deactivateBranch}>DESACTIVAR</button>
                        */}
                            {
                                this.props.type === 'UPDATE' && this.props.deliveryAddressData && this.props.deliveryAddressData.is_active === false &&
                                <button className="modal-buttonActivate" onClick={this.activateBranch}>ACTIVAR</button>
                            }
							<button className="modal-buttonNo" onClick={this.onPressCancel}>CERRAR</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeliveryAddressModal;